// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanLiteDto } from './IPlanLiteDto';
import {
    IPlanLiteDtoFromJSON,
    IPlanLiteDtoFromJSONTyped,
    IPlanLiteDtoToJSON,
    IPlanLiteDtoToJSONTyped,
} from './IPlanLiteDto';

/**
 * 
 * @export
 * @interface ISequenceOrderDto
 */
export interface ISequenceOrderDto {
    /**
     * 
     * @type {number}
     * @memberof ISequenceOrderDto
     */
    plan_template_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ISequenceOrderDto
     */
    order?: number;
    /**
     * 
     * @type {IPlanLiteDto}
     * @memberof ISequenceOrderDto
     */
    plan_template?: IPlanLiteDto;
}

/**
 * Check if a given object implements the ISequenceOrderDto interface.
 */
export function instanceOfISequenceOrderDto(value: object): value is ISequenceOrderDto {
    return true;
}

export function ISequenceOrderDtoFromJSON(json: any): ISequenceOrderDto {
    return ISequenceOrderDtoFromJSONTyped(json, false);
}

export function ISequenceOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISequenceOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_template_id': json['plan_template_id'] == null ? undefined : json['plan_template_id'],
        'order': json['order'] == null ? undefined : json['order'],
        'plan_template': json['plan_template'] == null ? undefined : IPlanLiteDtoFromJSON(json['plan_template']),
    };
}

export function ISequenceOrderDtoToJSON(json: any): ISequenceOrderDto {
    return ISequenceOrderDtoToJSONTyped(json, false);
}

export function ISequenceOrderDtoToJSONTyped(value?: ISequenceOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_template_id': value['plan_template_id'],
        'order': value['order'],
        'plan_template': IPlanLiteDtoToJSON(value['plan_template']),
    };
}

